import { AddDealInput } from 'api';
import { useEffect, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { QuoteWizardLoadingPort } from './QuoteWizardLoadingPort';

export const QuoteWizardLoadingPorts = () => {
  const { control } = useFormContext<AddDealInput>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'loadingPorts'
  });
  const [tempId, setTempId] = useState(-1);

  const handleAdd = () => {
    append({
      id: `L${tempId}`
    });
    setTempId(tempId - 1);
  };

  useEffect(() => {
    if (fields.length == 0) {
      handleAdd();
    }
    document.getElementById('frm-deal-wizard')?.scrollIntoView(false);
  }, [tempId]);

  return (
    <div>
      {fields.map((field, index) => {
        return (
          <QuoteWizardLoadingPort key={`loadingPorts-${field.id}`} handleRemove={remove} index={index} />
        );
      })}
    </div>
  );
};
